export default __webpack_public_path__ + "static/media/menu.25863d44.svg";